import React from 'react';
import { Grid, Typography } from '@mui/material';

const SectionSummary = ({ title, children }) => {
  return (
    <Grid
      container
      spacing={8}
      className="custom-input"
      sx={{ padding: '10px 0' }}
    >
      <Grid item xs={2} className="section-title">
        <Typography variant="h4" sx={{ fontSize: '16px' }}>
          {title}
        </Typography>
      </Grid>
      <Grid item xs={10}>
        <Grid container spacing={2} sx={{ padding: '10px 0' }}>
          {children}
        </Grid>
      </Grid>
      
    </Grid>
  );
};

export default SectionSummary;